import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "description-item-icon" }

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';

interface Props {
	icon?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionItemIcon',
  props: {
    icon: { default: 'asterisk' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(BaseIcon, {
      name: _ctx.icon,
      class: "description-item-icon__svg"
    }, null, 8 /* PROPS */, ["name"])
  ]))
}
}

})